import { useContext } from 'react'
import { CountryContext } from '../context/CountryContext'

export function useCountryContext() {
	const context = useContext(CountryContext)
	return context
}
